function Farms() {
    return (<><h1>Farms</h1></>);
}
export default Farms;